// extracted by mini-css-extract-plugin
export default {"CustomCurrency":"FormatNumberWithCurrency_CustomCurrency__pAu1R"};